import React, { forwardRef, memo } from 'react'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide
} from '@mui/material'

import customConfig from 'customConfig'
import SubmitButton from '../button/SubmitButton'
import Button from '../button/Button'
import CustomForm from '../inputs/CustomForm'
import FaIcon from '../faIcon/FaIcon'
import CardHeading from '../../text/CardHeading'

const Transition = forwardRef((props, ref) => (
  <Slide direction='up' ref={ref} {...props} />
))

const Popup = ({
  title,
  description,
  color,
  icon,
  children,
  disabledSubmit,
  onFormSubmit,
  submitLabel,
  cancelLabel,
  onCancel,
  status,
  submitBtnProps,
  leftAction,
  maxWidth = 'sm',
  fullWidth = true,
  customIcon,
  scroll
}) => {
  const isSubmitAvailable = onFormSubmit && submitLabel
  return (
    <Dialog
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      open
      onClose={onCancel}
      slots={{ transition: Transition }}
      scroll={scroll}
    >
      {(icon || customIcon) && (
        <Box
          component='span'
          sx={{
            pt: 3,
            pb: 1,
            mx: 'auto',
            display: 'inline-flex',
            color: color ? `${color}.main` : 'primary.main'
          }}
        >
          {customIcon ? customIcon : <FaIcon icon={icon} size='4x' />}
        </Box>
      )}
      <CustomForm onSubmit={onFormSubmit}>
        {(title || description) && (
          <DialogTitle sx={{ pb: 0 }}>
            <CardHeading title={title} desc={description} noMargin />
          </DialogTitle>
        )}
        {children && <DialogContent sx={{ mt: 3 }}>{children}</DialogContent>}
        {(cancelLabel || leftAction || isSubmitAvailable) && (
          <DialogActions sx={{ py: 3 }}>
            {cancelLabel && (
              <Button
                label={cancelLabel}
                onClick={onCancel}
                variant='outlined'
                color='inherit'
                size='large'
              />
            )}
            {leftAction}
            {isSubmitAvailable && (
              <SubmitButton
                label={submitLabel}
                loading={disabledSubmit}
                onClick={onFormSubmit}
                {...submitBtnProps}
              />
            )}
          </DialogActions>
        )}
        {status && status}
      </CustomForm>
    </Dialog>
  )
}

const { buttonStyles } = customConfig.customCss

Popup.defaultProps = {
  submitBtnProps: { css: buttonStyles }
}

export default memo(Popup)
